import type { JSX } from 'react'
import type { IBrandContainer } from '../BrandContainer'

import { BrandContainer } from '../BrandContainer'

export interface IBrandContainerDefault extends IBrandContainer {}

export const BrandContainerDefault = ({
  logoUrl,
  logoWidth = '144px',
  logoHeight = '40px',
  ...rest
}: IBrandContainer): JSX.Element => (
  <BrandContainer
    logoUrl={logoUrl}
    logoWidth={logoWidth}
    logoHeight={logoHeight}
    {...rest}
  />
)
